import { render, staticRenderFns } from "./En.vue?vue&type=template&id=0e2001e6&scoped=true"
import script from "./En.vue?vue&type=script&lang=js"
export * from "./En.vue?vue&type=script&lang=js"
import style0 from "./En.vue?vue&type=style&index=0&id=0e2001e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2001e6",
  null
  
)

export default component.exports